import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { APP_CONFIG } from '@kros-sk/core/app-config';
import { httpRetryAndLog } from '@kros-sk/core/http-retry';

import { PublicDocumentResponse } from '../types/public-document-view.types';

/**
 * The public viewer's bootstrap call: exchanges the delivery hash from the link for the document
 * payload. Everything addressed by a `DocumentReference` afterwards — the eInvoice XML, the PDFs —
 * goes through `DocumentViewApiService` (`@kros-sk/shared-esw/document-view`), which kros-office
 * shares.
 */
@Injectable({
  providedIn: 'root',
})
export class PublicDocumentViewApiService {
  readonly #appConfig = inject(APP_CONFIG);
  readonly #http = inject(HttpClient);
  readonly #url = `${this.#appConfig.gatewayApiUrl}/documentLink`;

  getDocumentLink(hash: string): Observable<PublicDocumentResponse<unknown>> {
    return this.#http.get<PublicDocumentResponse<unknown>>(this.#url, { params: { hash } }).pipe(
      httpRetryAndLog<PublicDocumentResponse<unknown>>({
        retryOnStatus: /^(500|502|503|504)$/,
        retryDelays: [1000, 2000, 4000],
      })
    );
  }
}
